export default [
    {
        path: "/suppliers/list-suppliers",
        name: "list-suppliers",
        meta: {title: "list-users", authRequired: true},
        component: () => import("../views/suppliers/list-suppliers"),
    }
]